// Locker
// ======

const CLASS_LOCKED = 'locked';

class Locker {
    static disableKeyDown(e) {
        e.preventDefault();
    }

    static lock(element) {
        element.addEventListener('keydown', Locker.disableKeyDown);
        element.classList.add(CLASS_LOCKED);
        element.tabIndex = -1;
    }

    static unlock(element) {
        element.removeEventListener('keydown', Locker.disableKeyDown);
        element.classList.remove(CLASS_LOCKED);
        element.tabIndex = 0;
    }
}

export default Locker;
